/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Item reference item: A pointer to another response item by ID.
 */
export type ItemReference = {
  type?: "item_reference" | undefined;
  id: string;
};

/** @internal */
export const ItemReference$inboundSchema: z.ZodType<
  ItemReference,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("item_reference").default("item_reference"),
  id: z.string(),
});
/** @internal */
export type ItemReference$Outbound = {
  type: "item_reference";
  id: string;
};

/** @internal */
export const ItemReference$outboundSchema: z.ZodType<
  ItemReference$Outbound,
  z.ZodTypeDef,
  ItemReference
> = z.object({
  type: z.literal("item_reference").default("item_reference" as const),
  id: z.string(),
});

export function itemReferenceToJSON(itemReference: ItemReference): string {
  return JSON.stringify(ItemReference$outboundSchema.parse(itemReference));
}
export function itemReferenceFromJSON(
  jsonString: string,
): SafeParseResult<ItemReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ItemReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ItemReference' from JSON`,
  );
}
